import * as React from "react";
import {SocialIcon} from "./SocialIcon";
import { FaInstagram } from 'react-icons/fa';

export function Instagram({isLarge = true}) {
    return <SocialIcon url="https://www.instagram.com/dragondrummergame/" isLarge={isLarge}>
        <FaInstagram/>
    </SocialIcon>
}